const unavailable = "—";
const renderableCategories = new Set([
  "success",
  "trade",
  "info",
  "error",
  "warning",
]);

/**
 * Read the clock time straight out of the timestamp string. GoldBot log
 * records are not always timezone qualified, so re-projecting them through
 * Date would silently shift the times the operator sees in the log file.
 */
export function formatEventTime(timestamp) {
  if (typeof timestamp !== "string") return unavailable;
  const match = timestamp.match(/[T ](\d{2}:\d{2}:\d{2})/);
  return match ? match[1] : unavailable;
}

export function buildEventRows(events) {
  return events.map((event, index) => ({
    id: `${event.timestamp || "event"}-${index}`,
    time: formatEventTime(event.timestamp),
    type: renderableCategories.has(event.category) ? event.category : "info",
    message: String(event.message || "").trim() || unavailable,
  }));
}

export function getEventStreamState({ data, error, isLoading }) {
  if (isLoading && !data) {
    return { eyebrow: "Loading events", message: "Loading events..." };
  }
  if (error) {
    return { eyebrow: "API unavailable", message: "Event stream unavailable" };
  }
  if (!data || !data.available) {
    return {
      eyebrow: "No log source",
      message:
        data?.unavailable_reason || "No GoldBot log source is available",
    };
  }
  if (!Array.isArray(data.events) || data.events.length === 0) {
    return { eyebrow: "No recent events", message: "No recent events" };
  }
  return {
    eyebrow: `${data.events.length} recent ${
      data.events.length === 1 ? "event" : "events"
    }`,
    message: null,
  };
}
